export default Object.freeze({
  AUTHENTICATION_FAIL: 'AUTHENTICATION_FAIL',
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
});
